module.exports = __webpack_public_path__ + "img/ewcode.0617ff58.png";